import { getServices } from '@/api/myTermine'
import { snrMappings } from '@/api/static'

function defaultServiceState() {
  return {
    services: null,
    selectedServicesId: [],
    selectedServicesName: [],
    selectedServicesLoaded: false,
  }
}

export default {
  state: () => ({
    ...defaultServiceState(),
  }),
  actions: {
    async getServices({ commit, rootState }) {
      try {
        const response = await getServices(rootState.states.selectedState.landesclubId)
        commit('setServices', response.data)
      } catch (error) {
        console.error(error)
      }
    },
    async getSnrMappings({ commit, state }, serviceSlug) {
      try {
        const response = await snrMappings(serviceSlug)
        const popular = state.services.oesterreichweit.items.find(
          (item) => item.snrId === +response.data.id
        )
        const other = state.services.ausgewaehlterLandesclub.items.find(
          (item) => item.snrId === +response.data.id
        )
        if (popular || other) {
          commit('addSelectedServicesId', +response.data.id)
          commit('addSelectedServicesName', response.data.bezeichnung)
        }
      } catch (error) {
        console.error(error)
      }
      commit('setSelectedServicesLoaded', true)
    },
  },
  mutations: {
    resetServiceState(state) {
      Object.assign(state, {
        ...state,
        ...defaultServiceState(),
      })
    },
    setServices(state, payload) {
      state.services = payload
    },
    addSelectedServicesId(state, payload) {
      state.selectedServicesId.push(payload)
    },
    setSelectedServicesId(state, payload) {
      state.selectedServicesId = payload
    },
    addSelectedServicesName(state, payload) {
      state.selectedServicesName.push(payload)
    },
    setSelectedServicesName(state, payload) {
      state.selectedServicesName = payload
    },
    setSelectedServicesLoaded(state, payload) {
      state.selectedServicesLoaded = payload
    },
  },
  getters: {
    services(state) {
      return state.services
    },
    selectedServicesId(state) {
      return state.selectedServicesId
    },
    selectedServicesName(state) {
      return state.selectedServicesName
    },
    selectedServicesLoaded(state) {
      return state.selectedServicesLoaded
    },
  },
}
